// extracted by mini-css-extract-plugin
export default {"primary-color":"#006266","secondaryColor":"#ff8945","container":"user-event-list-item_container__qSFDp","canceled":"user-event-list-item_canceled__2nZW4"};